type CompanyWithAliasOrName = {
  alias?: string
  name: string
}

export function getCompanyName(company: CompanyWithAliasOrName): string {
  return company?.alias ?? company?.name
}
